import {
  User
} from './../../../objects/real-time';
/*import {
  dns
} from './../../../providers/global.config';*/
import {
  NavParams
} from 'ionic-angular';
import {
  Component,
  ViewChild
} from '@angular/core';
import {
  Fueling,
  Provider,
  FuelingInfo,
  Type,
  DateInterval
} from '../model/index';
import {
  FuelingService
} from '../../../providers/fueling.service';
import {
  Subscription
} from 'rxjs/Subscription';
import {
  Observable
} from 'rxjs/Rx';
import {
  FileUploader
} from 'ng2-file-upload';
import {
  AlertController
} from 'ionic-angular/components/alert/alert-controller';
import {
  CarburantForm
} from './carburant-form/carburant-form';
import {
  ModalController
} from 'ionic-angular/components/modal/modal-controller';
import {
  ViewController
} from 'ionic-angular/navigation/view-controller';
import {
  NavController
} from 'ionic-angular/navigation/nav-controller';
import {
  Events
} from 'ionic-angular/util/events';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';

@Component({
  templateUrl: 'carburant.html'
})
export class Carburant {
  @ViewChild('mycontent') nav: NavController
  public uploader: FileUploader = new FileUploader({
   // url: dns + 'upload'
  });

  paymentTypes: Type[] = [];
  fuelProviders: Provider[] = [];
  idVehicule: number = 0;
  listFuels: FuelingInfo[] = null;
  multipar: any;
  formData: FormData = new FormData();
  fuel: FuelingInfo = new FuelingInfo();
  date: Date = new Date();
  showUpdate: Boolean = false;
  idProvider = 0;
  idType = 0;
  index: number = 0;
  providerName: string = null;
  showProvider: Boolean = false;
  showType: Boolean = false;
  typeName: string = null;
  matricule: string = null;
  indexFile: number = -1;
  item: any = null;
  subscriptionVehicule: Subscription;
  subscriptionUpload: Subscription;
  //dns: string = dns;
  dateIntervale: DateInterval = new DateInterval();
  operationTime: Date;
  endTime: Date;
  currentuser: any;
  constructor(private fuelingService: FuelingService,public toastCtrl:ToastController, public events: Events, navParams: NavParams, public viewCtrl: ViewController, public alertCtrl: AlertController, private modalCtrl: ModalController) {
    this.idVehicule = navParams.data.idDevice.idVehicule;
    this.matricule = navParams.data.matricule;
  }
  ngAfterViewInit() {
    this.currentuser = JSON.parse(localStorage.getItem('currentuser'));
    this.uploader.authToken = this.currentuser.token;
    this.fuelingService.getListType('PAYMENT').subscribe(response => {
      this.paymentTypes = response;
      console.log(response)
    });
    this.fuelingService.getProviders("FUEL").subscribe(response => {
      this.fuelProviders = response;
    });
    this.listFuels = [];
    this.fuelingService.getListFueling(this.idVehicule).subscribe(response => {
      this.listFuels = response;
      this.config();
      console.log(response)
    });

    this.subscriptionUpload = Observable.interval(100).subscribe(x => {
      this.uploader.onAfterAddingFile = (file) => {
        file.withCredentials = false;
      };
      if (this.item != null && this.indexFile >= 0)
        if (this.uploader.queue.length > 0) {
          if (this.uploader.queue[this.indexFile] != undefined && this.uploader.queue[this.indexFile].isSuccess) {
            this.item.isSuccess = false;
            this.item.remove();
            this.fuelingService.readData(this.idVehicule, this.item.file.name).subscribe(response => {
              if (response.length > 0) {
                for (let i = 0; i < response.length; i++) {
                  this.listFuels.push(response[i]);
                }

              } else {}
            }, () => {});
          }
        }
    });
  }
  //   ngOnDestroy() {
  //     this.subscriptionVehicule.unsubscribe();
  //     this.subscriptionUpload.unsubscribe();
  // }
  precisionRound(number: number, precision: number) {
    let factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
  }
  closeModal() {
    this.events.publish('Dismiss', null);
  }
  config() {
    this.operationTime = new Date();
    this.endTime = new Date();
    this.endTime.setFullYear(this.endTime.getFullYear() + 1);
    this.date = new Date();
    this.fuel.quantity = 0;
    this.fuel.odometre = 0;
    this.fuel.numberPayment = 0;
    this.fuel.costUnit = 0;
    this.fuel.cost = 0;
    this.fuel.observation = null;
    if (this.fuelProviders.length > 0) {
      this.idProvider = this.fuelProviders[0].id;
      this.showProvider = false;
    } else {
      this.showProvider = true;
    }
    if (this.paymentTypes.length > 0) {
      this.idType = this.paymentTypes[0].id;
      this.showType = false
    } else {
      this.showType = true;
    }
    this.showUpdate = false;
    this.providerName = null;
    this.typeName = null;
    this.fuel.id = 0;
  }

  uploadListener(item: any, indexFile: number) {
    this.item = item;
    this.indexFile = indexFile;

  }
  presentConfirm(fuel: any, i: any) {
    let alert = this.alertCtrl.create({
      title: 'Informations',
      message: 'Fournisseur:' + fuel.providerName + '<br> Odométre :' + fuel.odometre + '<br> Type Paiement : ' + fuel.type.name + '<br> Observation :' + fuel.observation + '<br> Num Paiement : ' + fuel.numberPayment + '',
      buttons: [{
          text: 'Ok',
          role: 'cancel',
          handler: () => {

          }
        },
        {
          text: 'Modifier',
          role: '',
          handler: () => {
            this.update(fuel)
          }
        }
      ]
    });
    alert.present();
    this.index = i;
  }
  update(fuel: any) {
    
    let fuelmodal = this.modalCtrl.create(CarburantForm, {
      fuel
    });
    fuelmodal.present();
    fuelmodal.onDidDismiss(data => {
      this.ngAfterViewInit();
      if (data) {
        this.fuelingService.update(data.fuel, data.idProvider, data.idType, data.providerName, data.typeName).subscribe((response) => {
          console.log(response)
          this.listFuels = this.listFuels.filter(fuel => fuel.id !== data.fuel.id);
          this.listFuels.splice(this.index, 0, response);
          this.paymentTypes = this.paymentTypes.filter(type => type.id !== response.type.id);
          this.paymentTypes.push(response.type);
          this.fuelProviders = this.fuelProviders.filter(provider => provider.id !== response.idProvider);
          let provider: Provider = new Provider();
          provider.id = response.idProvider;
          provider.name = response.providerName;
          this.fuelProviders.push(provider);
          this.config();
          let toast = this.toastCtrl.create({
            message: 'Carburant a été modifier avec succés',
            duration: 3000,
            position: 'top'
          });
          toast.present();
        }, () => {});

      }
    });
  }
  addFuel() {
    this.config();
    let fuelmodal = this.modalCtrl.create(CarburantForm, {
      fuel: this.fuel
    });
    console.log(this.fuel)
    fuelmodal.present();
    fuelmodal.onDidDismiss(data => {
      this.ngAfterViewInit();
        if (data) {
        this.fuel.operationTime = this.date.getTime();
        this.fuelingService.add(data.fuel, this.idVehicule, data.idProvider, data.idType, data.providerName, data.typeName).subscribe((response) => {
          this.listFuels.push(response);
          this.paymentTypes = this.paymentTypes.filter(type => type.id !== response.type.id);
          this.paymentTypes.push(response.type);
          this.fuelProviders = this.fuelProviders.filter(provider => provider.id !== response.idProvider);
          let provider: Provider = new Provider();
          provider.id = response.idProvider;
          provider.name = response.providerName;
          this.fuelProviders.push(provider);
          this.config();
          let toast = this.toastCtrl.create({
            message: 'Carburant a été ajouter avec succés',
            duration: 3000,
            position: 'top'
          });
          toast.present();
        }, () => {});
      }
    });
  }
  confirmDelete(fuel: FuelingInfo) {
    this.delete(fuel.id);
  }

  delete(id: number) {
    this.fuelingService.delete(id).subscribe((response) => {
      if (response) {
        this.listFuels = this.listFuels.filter(fuel => fuel.id !== id);
      } else {}
    }, () => {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/gestion-park/carburant/carburant.ts